import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    name: 'Sarah Mitchell',
    age: 54,
    location: 'Tampa, Florida',
    text: 'I had never heard about the oral microbiome before reading this guide. It gave me a completely different perspective on daily oral care.',
    initials: 'SM'
  }, {
    name: 'David Thompson',
    age: 61,
    location: 'Austin, Texas',
    text: "The information was easy to understand and helped me become more aware of habits I wasn't paying attention to.",
    initials: 'DT'
  }, {
    name: 'Elena Rodriguez',
    age: 49,
    location: 'San Diego, California',
    text: 'I appreciated how simple and practical everything was. Definitely worth the small investment.',
    initials: 'ER'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="py-20 bg-white" data-id="element-235">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-236">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold text-slate-900 mb-12" data-id="element-237">
          What Readers Are Saying
        </h2>

        <div className="relative bg-sky-50 rounded-2xl p-8 md:p-12 shadow-sm border border-slate-100" data-id="element-238">
          <div className="flex justify-center space-x-1 mb-6" data-id="element-239">
            {[...Array(5)].map((_, i) => <StarIcon key={i} size={22} className="fill-orange-400 text-orange-400" data-id="element-240" />)}
          </div>

          <div className="min-h-[180px] flex items-center justify-center relative" data-id="element-241">
            <AnimatePresence mode="wait" data-id="element-242">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} className="w-full" data-id="element-243">
                <p className="text-lg md:text-xl text-slate-700 font-playfair italic leading-relaxed mb-8" data-id="element-244">
                  "{testimonials[currentIndex].text}"
                </p>
                <div className="flex items-center justify-center space-x-3" data-id="element-245">
                  <div className="w-11 h-11 rounded-full bg-sky-500 text-white flex items-center justify-center text-sm font-bold" data-id="element-246">
                    {testimonials[currentIndex].initials}
                  </div>
                  <div className="text-left" data-id="element-247">
                    <div className="font-bold text-slate-900 text-sm" data-id="element-248">
                      {testimonials[currentIndex].name},{' '}
                      {testimonials[currentIndex].age}
                    </div>
                    <div className="text-xs text-slate-500 font-medium" data-id="element-249">
                      {testimonials[currentIndex].location}
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="flex justify-center space-x-4 mt-8" data-id="element-250">
            <button onClick={prev} className="p-2 rounded-full hover:bg-white transition-colors text-slate-400 hover:text-slate-700" aria-label="Previous testimonial" data-id="element-251">
              <ChevronLeftIcon size={24} data-id="element-252" />
            </button>
            <div className="flex space-x-2 items-center" data-id="element-253">
              {testimonials.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} aria-label={`Go to testimonial ${i + 1}`} className={`w-2 h-2 rounded-full transition-all ${i === currentIndex ? 'bg-orange-500 w-6' : 'bg-slate-300'}`} data-id="element-254" />)}
            </div>
            <button onClick={next} className="p-2 rounded-full hover:bg-white transition-colors text-slate-400 hover:text-slate-700" aria-label="Next testimonial" data-id="element-255">
              <ChevronRightIcon size={24} data-id="element-256" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}